import React from "react";

import { FrequentlyAskedQuestions } from "./FrequentlyAskedQuestions";
import { Contacts } from "./Contacts";

// import SVG from "react-inlinesvg";
// import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

import "../css/help-module.css";


export const Help = () => {
    // const backgrdImg = { 
    //     backgroundImage: 'url(./media/svg/illustrations/contact.svg)', 
    //     backgroundPosition: 'bottom', 
    //     backgroundRepeat: 'no-repeat' 
    // };

    return (
        <>
        <div className="card mb-7">
            <div>
                <div className="d-flex justify-content-center">
                    {/* <img
                        // style={{zIndex: 1, width: "1450px", height:"660px", position: "absolute", borderRadius: 5}} 
                        style={{zIndex: 1, width: "100%", height:"100%", position: "absolute", borderRadius: 5, opacity: 0.8}}
                        className="img-responsive"
                        src={'./media/svg/illustrations/contact.svg'}
                        alt="Contact Us"
                    /> */}
                    <Contacts/>
                </div>
            </div>
        </div>
        <div className="card mb-5">
            <div className="card-body m-5">
                {/* <div className="row p-10">
                    <div className="col-10"> */}
                        <FrequentlyAskedQuestions/>
                    {/* </div>
                    <div className="col-2">
                        <SVG 
                            src={toAbsoluteUrl('/media/svg/illustrations/copy.svg')}  
                            style={{ width: '100%', height: '100%' }}
                        />
                    </div>
                </div> */}
            </div>
        </div>
        </>
    )
};